import React, { useState } from 'react'
import Selectbox from '../../../shared/Select'
import searchIcon from "../../../../assets/img/icons/search-normal.svg"
const FaqSearch = () => {
    const [categories, setcategories] = useState()
    const catoption = [{
        value:"1",
        label:"1"
    },
    {
        value:"1",
        label:"1"
    },
    {
        value:"1",
        label:"1"
    }]

  return (
    <div className='FaqSearch'>
        <img src={searchIcon}/>
        <input placeholder='جست و جو کنید ...' className='FaqSearch__input'/>
     
        <Selectbox
     
            placeholder="نام دسته بندی"
            option={catoption}
            value={categories}
            onChange={value => setcategories(value)}
          />
      
        
    </div>
  )
}

export default FaqSearch